import React from 'react';

import styled from 'styled-components';
import { StyledButton } from 'styles/common';

import AddQuestionSrc from 'assets/images/AddQuestionImage.png';

import { AddCircularIcon } from 'constants/icons';

import { Typography10 } from 'uiToolkit/Typography';

const NoQuestionsScreen = ({ addQuestionHandler }) => (
  <Container>
    <img src={AddQuestionSrc} height="150px" />
    <Typography10 topGutter={2} bottomGutter={4} color="textSecondary" variant="body1" style={{ fontSize: '14px' }}>
      Add questions directly from question library which will open in the right panel
    </Typography10>
    <StyledButton color="primary" startIcon={<AddCircularIcon color="primary" />} onClick={addQuestionHandler}>
      Add Question
    </StyledButton>
  </Container>
);

export default NoQuestionsScreen;

const Container = styled.div`
  padding: 4rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: white;
  border-radius: 5px;
`;
